import { useCallback, useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import {
  EMPTY_BOOST_CAMPAIGN_CRITERIA,
  fetchBoostCampaignCriteriaFull,
  hasBoostCampaignBeenSaved,
  normalizeBoostCampaignCriteria,
} from "./boostCampaignCriteria"

/** Load saved My MLS boost campaign criteria from the API. */
export function useMyMlsBoostCampaign({ loadOnMount = true } = {}) {
  const axios = useAuthorizedAxiosClient()
  const [isLoading, setIsLoading] = useState(Boolean(loadOnMount))
  const [criteria, setCriteria] = useState({ ...EMPTY_BOOST_CAMPAIGN_CRITERIA })
  const [updatedAt, setUpdatedAt] = useState(null)

  const applyPayload = useCallback((payload) => {
    setCriteria(normalizeBoostCampaignCriteria(payload?.criteria))
    setUpdatedAt(payload?.updatedAt || null)
  }, [])

  const loadSavedCriteria = useCallback(() => {
    setIsLoading(true)
    return fetchBoostCampaignCriteriaFull(axios)
      .then(applyPayload)
      .finally(() => setIsLoading(false))
  }, [axios, applyPayload])

  useEffect(() => {
    if (loadOnMount) {
      loadSavedCriteria()
    }
  }, [loadOnMount, loadSavedCriteria])

  return {
    isLoading,
    criteria,
    updatedAt,
    hasSaved: hasBoostCampaignBeenSaved({ criteria, updatedAt }),
    loadSavedCriteria,
    applyPayload,
  }
}
